import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const Messageservice = {
  getList: async () => {
    const response = await apiService.get("/message-from-ceo");
    console.log(response);
    return response.data;
  },
  create: async (data) => {
    const response = await apiService.post("/message-from-ceo", data);
    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/message-from-ceo/${id}`);

    return response.data;
  },

  getbySlug: async (slug) => {
    const response = await apiService.get(`/message-from-ceo/by-slug/${slug}`);
    return response.data;
  },
  update: async (id, updateData) => {
    try {
      const response = await apiService.put(`/message-from-ceo/${id}`, updateData);
      return response.data;
    } catch (error) {
      console.error("Error updating Universities", error);
      throw error;
    }
  },
  delete: async (id) => {
    const response = await apiService.delete(`/message-from-ceo/${id}`);
    return response.data;
  },
};
export default Messageservice;